export const MANUAL_REVIEW_TASK_TYPES = ['buy_fvt', 'likes_on_repost'];

export const isManualReviewTask = (task) => MANUAL_REVIEW_TASK_TYPES.includes(task.task_type);

export const getTaskStatus = (task, optimisticStatuses = {}) => {
  if (task.is_completed) return 'completed';
  if (optimisticStatuses[task.id] === 'pending_review') return 'pending_review';
  if (task.is_pending_review) return 'pending_review';
  if (task.is_maxed) return 'completed';
  return 'open';
};
